import React from 'react'
import VisDiv from './frontend_components/VisDiv'

const BottomMobileMenu = ({clickRegister, clickWorksheet, isWorksheet}) => {

  const color = {backgroundColor:"red", color: 'white'}
  return (
        <div  className='bottom-menu'>
            <VisDiv className='tab' onClick={clickRegister} style={{backgroundColor: !isWorksheet && "#00127b", color: !isWorksheet && 'white'}}>
                REGISTRO
            </VisDiv>
            <VisDiv className='tab' onClick={clickWorksheet} style={{backgroundColor: isWorksheet && "#00127b", color: isWorksheet && 'white'}}>
                FOGLIO DI LAVORO
            </VisDiv>
        </div>
  )
}

export default BottomMobileMenu
